import React, { useEffect, useState } from 'react';
import { Spin, notification, } from 'antd';

import Api from 'config/api';
import { formatNumberAsCurrency } from 'utils/helpers'

import { SlantedLine } from 'assets/svgs';

import './index.scss';

export default function BudgetAllocation() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [year] = useState(2020);
  
  useEffect(() => {
    getBudget();
  }, []);

  const summaryItems = [
    {
      title: 'Total Allocation',
      amount: `₦${formatNumberAsCurrency(data?.totalAllocation, 2)}`,
    },
    {
      title: 'Recurrent Expenditure',
      amount: `₦${formatNumberAsCurrency(data?.totalRecurrent, 2)}`,
    },
    {
      title: 'Capital Expenditure',
      amount: `₦${formatNumberAsCurrency(data?.totalCapital)}`,
    },
  ];

  const getBudget = async () => {
    setLoading(true);
    try {
      const response = await Api.get(`budget/year?year=${year}`);
      setData(response?.data?.data);
    } catch ({ message, status }) {
      notification.error({
        message: `Status code: ${status}`,
        description: `Failed to load Unemployment Data. ${message}`,
      });
    }
    setLoading(false);
  };


  const renderSummaryItems = ({ item, index }) => (
    <div className="summary-items">
      <div className="d-flex flex-column justify-content-center">
        <p>{!loading ? item.amount : ''}</p>
        <p>{item.title}</p>
      </div>
      {index < 2 && <SlantedLine />}
    </div>
  );
  
  return (
    <Spin spinning={loading}>
      <div className="budget-allocation">

        <div className="budget-allocation__summary">
          {summaryItems.map((item, index) => (
            <React.Fragment key={index}>
              {renderSummaryItems({ item, index })}
            </React.Fragment>
          ))}
        </div>
      </div>
    </Spin>
  );
}

